import { configureStore } from "@reduxjs/toolkit";
import { api } from "../api";
import authReducer from "./slices/authSlice";
import pendingRequestsReducer from "./slices/pendingRequestsSlice";
import investmentReducer from "./slices/investmentSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        pendingRequests: pendingRequestsReducer,
        investment: investmentReducer,
        [api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
